/**
 * The caller's own Rocket.Chat username, on their profile — this module's
 * contribution to core's `profile.sections` slot.
 *
 * Read only. A username decides who reads a direct message, so only an
 * administrator changes it; the person it belongs to is the one most likely to
 * notice it is wrong, so they see it here and know whom to ask.
 */
import { useTranslation } from 'react-i18next';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { AsyncContent } from '../../components/AsyncContent';
import { Details } from '../../components/Details';
import { Panel } from '../../components/Panel';
import { useAsync } from '../../hooks/useAsync';
import { getOwnHandle } from './api';

export function OwnRocketChatHandlePanel() {
  const { t } = useTranslation('rocketchat');
  const handle = useAsync(getOwnHandle, []);

  return (
    <Panel icon={<ForumOutlinedIcon fontSize="small" />} title={t('profile.title')}>
      <AsyncContent state={handle} placeholder="spinner">
        {({ handle: { username } }) => (
          <Stack spacing={2}>
            <Typography variant="body2" color="text.secondary">
              {username === null ? t('profile.none') : t('profile.description')}
            </Typography>
            <Details rows={[[t('profile.username'), username !== null && `@${username}`]]} />
          </Stack>
        )}
      </AsyncContent>
    </Panel>
  );
}
